import { UiIconButtonVanilla } from '@skillbox/front-box/dist/Buttons/UiIconButton/UiIconButtonVanilla'

export const createUiVideoModalTemplate = (theme) => {
  return (
    `<section class="ui-video-modal">
      <div class="ui-video-modal__wrapper">
        ${UiIconButtonVanilla({
          theme: 'filled-secondary',
          icon: 'ui-close',
          ariaLabel: 'Закрыть модальное окно',
          classes: 'ui-video-modal__close'
        })}

        <div
          class="ui-video-modal__video ui-video-modal__video--${theme}"
          data-element="content-wrapper"
        >
          <div></div>
        </div>

        <!-- Ловушка для фокуса, чтобы не проваливался через iframe -->
        <span tabindex="0" />
      </div>
    </section>`
  )
}
